import {
  Badge,
  Col,
  Popover,
  PopoverBody,
  Row,
  Spinner,
  Table,
  UncontrolledTooltip,
  Button
} from "reactstrap";
import SingleMetricChart from "./SingleMetricData";
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getIntegrationLogo, getLocalDateTime, getUserColor} from "../helpers/component_helpers";
import Runbook from "./Runbooks/Runbook";
import CreateRunbook from "./Runbooks/CreateRunbook";
import SlickHorizontalTimeline from "./EventTimeline";
import CardItem from "./PurpleTheme/CardItem";
import {Link} from "react-router-dom";
import InitialsAvatar from "../pages/Profile/InitialsAvatar";
import profileImg from "../assets/images/profile.png";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import {
  getAlertCorrelation, getAlertLogDetails,
  getAlertLogStatusHistory,
  getErrorLogs, getMetricDataByAlertLogId, getPastAiConversations,
  getRunbook,
  getRunbookStepsResultsByAlertLogId, getUserExecutedStepsResultsByAlertLogId,
  startAiConversation, getAgentAvailable, sendApprovalDecision
} from "../store/alertlog/actions";
import {getOrganization, getRecentChangeEvents} from "../store/organization/actions";

const RootCauseAnalysis = ({showAllMetricsComponents, render_view_metrics_button=true, restrictHeight=false}) => {

  const navigate = useNavigate();

  const {metrics_data_by_alert_log_id} = useSelector(state => ({
    metrics_data_by_alert_log_id: state.AlertLog.metrics_data_by_alert_log_id
  }));
  const { alert_correlation_data } = useSelector(state => ({
    alert_correlation_data: state.AlertLog.alert_correlation_data}))
  const { id } = useParams();

  const dispatch = useDispatch();
  const {runbook} = useSelector(state => ({runbook: state.AlertLog.runbook}))

  const { alert } = useSelector((state) => {
    const correlationData = state.AlertLog.alert_correlation_data;
    const hasRootCause = correlationData?.root_cause_alert_details && Object.keys(correlationData.root_cause_alert_details).length > 0;

    return {
      alert: hasRootCause ? correlationData.root_cause_alert_details : state.AlertLog.alert
    };
  });


  const {alertStatusHistory} = useSelector(state => ({
    alertStatusHistory: state.AlertLog.alertStatusHistory
  }));

  const {runbook_results_by_alert_log_id} = useSelector(state => ({
    runbook_results_by_alert_log_id: state.AlertLog.runbook_results_by_alert_log_id
  }))

  const {user_executed_results_by_alert_log_id} = useSelector(state => ({
    user_executed_results_by_alert_log_id: state.AlertLog.user_executed_results_by_alert_log_id
  }))

  const { ai_response, isStreaming, past_ai_conversation, agent_availability, approval_required, approval_message } = useSelector(state => ({
    ai_response: state.AlertLog.ai_response,
    isStreaming: state.AlertLog.isStreaming,
    past_ai_conversation: state.AlertLog.past_ai_conversation,
    agent_availability: state.AlertLog.agent_availability,
    approval_required: state.AlertLog.approval_required,
    approval_message: state.AlertLog.approval_message
  }));


  const [approvalRequired, setApprovalRequired] = useState(false);
  const [approvalMessage, setApprovalMessage] = useState("");
  const [showAllMetrics, setShowAllMetrics] = useState(showAllMetricsComponents);
  const [runbookView, setRunbookView] = useState(true);
  const [createRunbookView, setCreateRunbookView] = useState(false);
  const [aiChatMessage, setAiChatMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const messagesEndRef = useRef(null);
  const [showAllTroubleshooting, setShowAllTroubleshooting] = useState(false);

  useEffect(() => {
    if (past_ai_conversation.length > 0) {
      const lastMessage = past_ai_conversation[past_ai_conversation.length - 1];
      if (lastMessage.conversation_type === "interrupt") {
        setApprovalRequired(true);
        setApprovalMessage(lastMessage.interrupt_message || "Interrupt message");
      } else {
        setApprovalRequired(false);
        setApprovalMessage("");
      }
    }
  }, [past_ai_conversation]);


  const stateApprovalRequired = (approval_required || approvalRequired)
  useEffect(() => {
    const alertLogCompletedStatus = ["Ran Diagnostics", 'Ok'];
    let intervalRef = null;
    const isAlertOngoing = () => {
      const latestAlertStatus = alert?.status || '';
      if (latestAlertStatus === 'Ok') {
        return false
      }
      const sortedStatusHistory = alertStatusHistory?.status_history?.slice().sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      const latestStatus = sortedStatusHistory?.[0]?.status;
      if (alertLogCompletedStatus.includes(latestStatus)) {
        return false
      }

      // If the alert has been opened for more than 30 minutes then consider it as not ongoing
      const openedAt = new Date(alert?.opened_at);
      const now = new Date();
      const timeDiff = Math.abs(now - openedAt);
      const diffInMinutes = Math.floor(timeDiff / (1000 * 60));
      return diffInMinutes <= 30;
    };

    const fetchData = () => {
      if (id !== undefined) {
        dispatch(getAlertLogStatusHistory(id));
        dispatch(getMetricDataByAlertLogId(id));
        dispatch(getRunbook(id));
        dispatch(getAlertLogDetails(id));
        dispatch(getRunbookStepsResultsByAlertLogId(id))
        dispatch(getUserExecutedStepsResultsByAlertLogId(id))
      }
    };
    if (id !== undefined) {
      intervalRef = setInterval(() => {
        if (isAlertOngoing()) {
          fetchData();
        } else {
          clearInterval(intervalRef);
        }
      }, 10000);
    }

    return () => {
      if (intervalRef) {
        clearInterval(intervalRef);
      }
    };
  }, [id, alert]);
  const [alertPopover,setAlertPopover] = useState({});
  const [popoverOpen2, setPopoverOpen2] = useState({});
  const [popoverOpen3, setPopoverOpen3] = useState({});
  const [popoverOpen4, setPopoverOpen4] = useState({});
  const [userColors,setUserColors] = useState([])
  const [currentRunbookIndex, setCurrentRunbookIndex] = useState(0);
  const [unreadCount, setUnreadCount] = useState(0);
  const viewRunbook = () => {
    runbookView === false ? setRunbookView(true) : setRunbookView(false);
  }

  const runbookRef = useRef(null);

  useEffect(() => {
    setShowAllMetrics(showAllMetricsComponents)
  }, [showAllMetricsComponents]);

  useEffect(() => {
    let userColorsMap = [];
    alert_correlation_data?.associated_alerts?.map((alert, index) => {
      if (alert.assigned_to) {
        let userColor = {};
        userColor = {
          id: alert.assigned_to.id,
          name: alert.assigned_to.name,
          color: getUserColor(alert.assigned_to.email),
        }
        userColorsMap.push(userColor);
      }
    });
    setUserColors(userColorsMap);
  }, [alert_correlation_data]);

  useEffect(() => {
    dispatch(getOrganization())
    dispatch(getRunbook(id))
    dispatch(getAlertCorrelation(id))
    dispatch(getAlertLogStatusHistory(id));
    dispatch(getRunbookStepsResultsByAlertLogId(id))
    dispatch(getMetricDataByAlertLogId(id));
    dispatch(getPastAiConversations(id));
    dispatch(getAlertLogDetails(id));
    dispatch(getAgentAvailable(id));
    dispatch(getUserExecutedStepsResultsByAlertLogId(id))
  }, [id])

  useEffect(() => {
    const formattedMessages = past_ai_conversation
      .flatMap(msg => {
        const messages = [];

        if (msg.user_input) {
          messages.push({
            type: 'user',
            content: msg.user_input,
            timestamp: msg.created_at,
            user_name: msg.user_name || 'You',
            message_type: msg.conversation_type || 'general',
          });
        }

        if (msg.ai_response) {
          messages.push({
            type: 'ai',
            content: msg.ai_response,
            timestamp: msg.updated_at,
            message_type: msg.conversation_type || 'general',
          });
        }

        if (msg.conversation_type === "interrupt") {
          messages.push({
            type: 'ai',
            content: msg.interrupt_message,
            timestamp: msg.created_at,
            user_name: msg.user_name || 'You',
            message_type: 'interrupt',
          });
        }

        return messages;
      });

    setMessages(formattedMessages);
  }, [past_ai_conversation.length]);


  const handleMouseEnterAlert = (id) => {
    setAlertPopover(prevState => ({
      ...prevState,
      [id]: true,
    }));
  };

  const handleMouseLeaveAlert = (id) => {
    setAlertPopover(prevState => ({
      ...prevState,
      [id]: false,
    }));
  };
  const togglePopoverMetric = (key, isOpen) => {
    setPopoverOpen4(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const togglePopoverResource = (key, isOpen) => {
    setPopoverOpen3(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const handleMouseEnterService = (key) => {
    togglePopoverService(key, true);
  };

  const handleMouseLeaveService = (key) => {
    togglePopoverService(key, false);
  };
  const handleMouseEnterResource = (key) => {
    togglePopoverResource(key, true);
  };

  const handleMouseEnterMetric = (key) => {
    togglePopoverMetric(key, true);
  };
  const handleMouseLeaveMetric = (key) => {
    togglePopoverMetric(key, false);
  };

  const handleMouseLeaveResource = (key) => {
    togglePopoverResource(key, false);
  };

  const togglePopoverService = (key, isOpen) => {
    setPopoverOpen2(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const alertOngoingStatus = [
    "Generated Runbook",
    "Generating Runbook",
    "Running Diagnostics",
    "Sent Notification",
    "Analyzed Metrics",
    "Analyzing Metrics",
    "Sending Notification",
    "Created",
    "Analyzing",
    "Fetching Contextual Logs",
    "Fetched Logs",
    "Executing Diagnostics",
    "Executing Recovery",
    "success",
    "failed"
  ]

  const alertLogCompletedStatus = ["Ran Diagnostics", 'Ok']

  const sortedStatusHistory = alertStatusHistory?.status_history?.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  const latestStatus = sortedStatusHistory?.[0]?.status;

  const currentAlertStatus = alert?.status || '';
  let isOngoing = !alertLogCompletedStatus.includes(latestStatus) && currentAlertStatus !== 'Ok';

  const renderMessageWithCodeBlocks = (content) => {
    // Ensure content is always treated as a string
    const contentStr = String(content);

    try {
      const parts = contentStr.split(/(```[\s\S]*?```)/g);

      return parts.map((part, index) => {
        if (part.startsWith('```') && part.endsWith('```')) {
          const languageMatch = part.match(/^```(\w+)/);
          const language = languageMatch ? languageMatch[1] : '';
          const codeContent = part.replace(/^```(\w+)?/, '').replace(/```$/, '').trim();

          return (
            <div key={index} style={{
              backgroundColor: '#1a1025',
              padding: '16px',
              margin: '8px 0',
              borderRadius: '8px',
              borderLeft: '4px solid #6e45a0',
              overflowX: 'auto',
              fontFamily: 'monospace',
              fontSize: '0.9rem',
              position: 'relative'
            }}>
              {language && (
                <div style={{
                  position: 'absolute',
                  top: '8px',
                  right: '12px',
                  color: '#b39ddb',
                  fontSize: '0.7rem',
                  textTransform: 'uppercase'
                }}>
                  {language}
                </div>
              )}
              <pre style={{
                margin: '0',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                color: '#e0d6f0'
              }}>
              {codeContent}
            </pre>
            </div>
          );
        }

        // Handle inline code (between backticks)
        const textParts = part.split(/(`[^`]+`)/g);
        return (
          <span key={index}>
          {textParts.map((text, textIndex) => {
            if (text.startsWith('`') && text.endsWith('`')) {
              return (
                <code key={textIndex} style={{
                  backgroundColor: 'rgba(110, 69, 160, 0.3)',
                  padding: '2px 4px',
                  borderRadius: '4px',
                  fontSize: '0.9em'
                }}>
                  {text.slice(1, -1)}
                </code>
              );
            }
            return text;
          })}
        </span>
        );
      });
    } catch (error) {
      console.error('Error rendering message:', error);
      return contentStr; // Fallback to plain text if parsing fails
    }
  };

  const renderResult = (result) => {
    try {
      // Check if result is a string that can be parsed as JSON
      const parsedResult = typeof result === 'string' ? JSON.parse(result) : result;

      // Check if it's an array of objects
      if (Array.isArray(parsedResult) && parsedResult.length > 0 && typeof parsedResult[0] === 'object') {
        // Get all unique keys from all objects
        const headers = [...new Set(parsedResult.flatMap(obj => Object.keys(obj)))];

        return (
          <div style={{
            maxHeight: '300px',
            width: '100%'
          }}>
            <div style={{
              overflowX: 'auto',
              overflowY: 'auto',
              maxHeight: '300px',
              width: '100%'
            }}>
              <Table bordered hover style={{
                color: '#FFFFFF',
                fontSize: '12px',
                width: '100%'
              }}>
                <thead>
                <tr>
                  {headers.map((header, index) => (
                    <th key={index} style={{
                      color: '#FFFFFF',
                      padding: '12px',
                      borderColor: '#4B4B4B',
                      maxWidth: '200px',
                      width: 'auto',
                      overflow: 'visible'
                    }}>{header}</th>
                  ))}
                </tr>
                </thead>
                <tbody>
                {parsedResult.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {headers.map((header, colIndex) => (
                      <td key={colIndex} style={{
                        color: '#FFFFFF',
                        padding: '12px',
                        borderColor: '#4B4B4B',
                        maxWidth: '200px',
                        width: 'auto',
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        hyphens: 'auto'
                      }}>{(row[header] || '').toString()}</td>
                    ))}
                  </tr>
                ))}
                </tbody>
              </Table>
            </div>
          </div>
        );
      }

      // If not an array of objects, return as pre-formatted text
      return (
        <pre style={{
          padding: "10px",
          color: "#FFFFFF",
          whiteSpace: "pre-wrap",
          fontSize: "10px",
          wordBreak: "break-word",
          backgroundColor: 'black',
          maxHeight: '300px',
        }}>
          {typeof result === 'string' ? result : JSON.stringify(result, null, 2)}
        </pre>
      );
    } catch (error) {
      // If parsing fails, return as pre-formatted text
      return (
        <pre style={{
          padding: "10px",
          color: "#FFFFFF",
          whiteSpace: "pre-wrap",
          fontSize: "10px",
          wordBreak: "break-word",
          backgroundColor: 'black',
          maxHeight: '300px',
        }}>
          {result}
        </pre>
      );
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (ai_response) {
      setMessages(prevMessages => [...prevMessages, { type: 'ai', content: ai_response }]);
    }
  }, [ai_response]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = () => {
    if (!aiChatMessage.trim() || isStreaming) return;

    const payload = {
      alert_log_id: id,
      user_input: aiChatMessage
    };

    setMessages(prevMessages => [
      ...prevMessages,
      { type: 'user', content: aiChatMessage }
    ]);

    dispatch(startAiConversation(payload));

    if (!render_view_metrics_button) {
      navigate(`/alert-log-analysis/${id}`);
    }

    setAiChatMessage('');
  };

  function handleApprovalResponse(accepted) {
    const payload = {
      alert_log_id: id,
      user_input: accepted ? 'yes' : 'no'
    };

    dispatch(sendApprovalDecision(payload));
    setAiChatMessage('');
  }


  return (
    <>
      <div style={{
        width: '100%',
        // maxHeight: restrictHeight ? '500px' : 'none',
        // overflowY: restrictHeight ? 'auto' : 'visible',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'row',
        minHeight: render_view_metrics_button && agent_availability.render_agent_chat? '100vh' : 'auto',
        marginLeft: '5%',
        // background: '#18122b'
      }}>
        {/* Left/Main Content */}
        <div style={{
          flex: 1,
          minWidth: 0,
          width: '100%',
          marginRight: render_view_metrics_button && agent_availability.render_agent_chat ? '35%' : "10%", // Prevents content from being hidden behind chat
        }}>
          <h4>Root Cause Analysis
            <img src="/icons/ai-compressed.png" alt="Customize Icon" className="ms-2 me-2 ai-svg-icon"/>
            {isOngoing && (
              <>
                <Spinner id="statusSpinner" className="ms-2" color="warning" size="sm" style={{animationDuration: '1.5s'}}/>
                <UncontrolledTooltip placement="top" target="statusSpinner">
                  {latestStatus}
                </UncontrolledTooltip>
              </>
            )}
          </h4>
          {alert_correlation_data?.associated_alerts?.length > 0 && (
            <h5 className="mt-3">Correlated Alerts</h5>
          )}
          {alert_correlation_data?.associated_alerts?.map((item, index) => {
            const alertNameId = `alertlog-alert-name-${item.id}`;
            const serviceNameId = `alertlog-service-name-${item.id}`;
            const resourceId = `alertlog-resource-${item.id}`;
            const metricId = `alertlog-metric-${item.id}`;
            const tooltipId = `TooltipTop_${index}`;
            const isRoot = item?.is_root_cause;
            const cardClass = isRoot ? 'carditem-root-cause' : '';

            if (!render_view_metrics_button) {
              return (
                <CardItem key={index} className={cardClass}>
                  <Row className="align-items-center">
                    <Col md="6" className="align-items-start">
                      <div className="d-flex align-items-center justify-content-center">
                        <img
                          src={getIntegrationLogo(
                            item.integration_type || alerts?.find(a => a?.id === item?.id)?.integration_type
                          )}
                          alt={item.integration_type}
                          className="rounded-circle"
                          style={{width: '20px', height: '20px'}}
                        />
                        <Link
                          className="resource-name-truncate text-center"
                          style={{marginLeft: "0.25rem"}}
                          id={alertNameId + `-${index}`}
                          to={`/alert-log/${item.id}`}
                          target={'_blank'}
                          onMouseEnter={() => handleMouseEnterAlert(item.id)}
                          onMouseLeave={() => handleMouseLeaveAlert(item.id)}
                        >
                          {item.name.length > 25 ? `${item.name.substring(0, 50)}...` : item.name}
                        </Link>
                        <Popover
                          isOpen={alertPopover[item.id] || false}
                          target={alertNameId + `-${index}`}
                          placement="top"
                          style={{ pointerEvents: "none" }} // Prevents interference with clicks
                        >
                          <PopoverBody>{item.name}</PopoverBody>
                        </Popover>
                        {isRoot && (
                          <i className="badge rounded-pill badge-soft-danger position-absolute"
                             style={{
                               top: '-50%',
                               right: '0px',
                               fontStyle: 'italic',
                             }}>
                            Root Cause
                          </i>
                        )}
                      </div>
                    </Col>
                    <Col md="3" className="text-center">
                      <h6 className="resource-name-truncate mb-0">
                        <Link
                          id={serviceNameId + `-${index}`}
                          to={`/temperstack-notifications/${item.application_service_id}`}
                          onMouseEnter={() => handleMouseEnterService(item.id)}
                          onMouseLeave={() => handleMouseLeaveService(item.id)}
                          className="link-primary text-center"
                        >
                          {item.application_service.name}
                        </Link>
                        <Popover isOpen={popoverOpen2[item.id] || false}
                                 target={serviceNameId + `-${index}`}
                                 placement="top">
                          <PopoverBody>{item.application_service.name}</PopoverBody>
                        </Popover>
                      </h6>
                    </Col>

                    <Col md="2" className="text-center">
                      <Badge
                        className="font-size-10"
                        color={
                          item.status === "Alarm"
                            ? "danger"
                            : item.status === "Ok"
                              ? "success"
                              : "warning"
                        }
                      >
                        {item.status === "Acknowledged" ? "Acked" : item.status}
                      </Badge>
                    </Col>

                    <Col md="1" className="text-center" style={{ justifyContent: 'center', display: 'flex' }}>
                      {item.assigned_to?.profile_picture_url ? (
                        <div>
                          <img
                            id={tooltipId + `-${index}`}
                            src={item.assigned_to?.profile_picture_url}
                            alt="Profile"
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                              marginBottom: "10px"
                            }}
                          />
                          <UncontrolledTooltip placement="top" target={tooltipId + `-${index}`}>
                            {item.assigned_to?.name}
                          </UncontrolledTooltip>
                        </div>
                      ) : item.assigned_to?.name ? (
                        <div>
                          <InitialsAvatar
                            name={item.assigned_to?.name}
                            id={tooltipId + `-${index}`}
                            userColor={
                              userColors.find(user => user.id === item.assigned_to?.id)?.color
                            }
                            dimensions="25px"
                            marginBottom="0"
                          />
                          <UncontrolledTooltip placement="top" target={tooltipId + `-${index}`}>
                            {item.assigned_to?.name}
                          </UncontrolledTooltip>
                        </div>
                      ) : (
                        <img
                          src={profileImg}
                          alt="default profile"
                          style={{ height: "30px", width: "30px" }}
                        />
                      )}
                    </Col>
                  </Row>
                </CardItem>
              );
            }

            return (
              <CardItem key={index} className={cardClass}>
                <Row className="align-items-center">
                  <Col md="4" className="align-items-start">
                    <div className="d-flex align-items-center justify-content-center">
                      <img
                        src={getIntegrationLogo(
                          item.integration_type || alerts?.find(a => a?.id === item?.id)?.integration_type
                        )}
                        alt={item.integration_type}
                        className="rounded-circle"
                        style={{width: '20px', height: '20px'}}
                      />
                      <Link
                        className="resource-name-truncate text-center"
                        style={{marginLeft: "0.25rem"}}
                        id={alertNameId}
                        to={`/alert-log/${item.id}`}
                        onMouseEnter={() => handleMouseEnterAlert(item.id)}
                        onMouseLeave={() => handleMouseLeaveAlert(item.id)}
                      >
                        {item.name.length > 25 ? `${item.name.substring(0, 50)}...` : item.name}
                      </Link>
                      <Popover isOpen={alertPopover[item.id] || false} target={alertNameId} placement="top">
                        <PopoverBody>{item.name}</PopoverBody>
                      </Popover>
                      {isRoot && (
                        <i className="badge rounded-pill badge-soft-danger position-absolute"
                           style={{
                             top: '-50%',
                             right: '0px',
                             fontStyle: 'italic',
                           }}>
                          Root Cause
                        </i>
                      )}
                    </div>
                  </Col>
                  <Col md="1" className="text-center">
                    <h6 className="resource-name-truncate mb-0">
                      <Link
                        id={serviceNameId}
                        to={`/temperstack-notifications/${item.application_service_id}`}
                        onMouseEnter={() => handleMouseEnterService(item.id)}
                        onMouseLeave={() => handleMouseLeaveService(item.id)}
                        className="link-primary text-center"
                      >
                        {item.application_service.name}
                      </Link>
                      <Popover isOpen={popoverOpen2[item.id] || false} target={serviceNameId} placement="top">
                        <PopoverBody>{item.application_service.name}</PopoverBody>
                      </Popover>
                    </h6>
                  </Col>

                  <Col md="2" className="text-center">
                    <h6
                      id={resourceId}
                      className="resource-name-truncate mb-0"
                      onMouseEnter={() => handleMouseEnterResource(item.id)}
                      onMouseLeave={() => handleMouseLeaveResource(item.id)}
                    >
                      {item.resource_name}
                    </h6>
                    <Popover isOpen={popoverOpen3[item.id] || false} target={resourceId} placement="top">
                      <PopoverBody>{item.resource_name}</PopoverBody>
                    </Popover>
                  </Col>

                  <Col md="1" className="text-center">
                    <h6
                      id={metricId}
                      className="resource-name-truncate mb-0"
                      onMouseEnter={() => handleMouseEnterMetric(item.id)}
                      onMouseLeave={() => handleMouseLeaveMetric(item.id)}
                    >
                      {item.metric_name}
                    </h6>
                    <Popover isOpen={popoverOpen4[item.id] || false} target={metricId} placement="top">
                      <PopoverBody>{item.metric_name}</PopoverBody>
                    </Popover>
                  </Col>

                  <Col md="1" className="text-center">
                    <Badge
                      className="font-size-10"
                      color={
                        item.status === "Alarm"
                          ? "danger"
                          : item.status === "Ok"
                            ? "success"
                            : "warning"
                      }
                    >
                      {item.status === "Acknowledged" ? "Acked" : item.status}
                    </Badge>
                  </Col>

                  <Col md="1" className="text-center" style={{ justifyContent: 'center', display: 'flex' }}>
                    {item.assigned_to?.profile_picture_url ? (
                      <div>
                        <img
                          id={tooltipId}
                          src={item.assigned_to?.profile_picture_url}
                          alt="Profile"
                          style={{
                            borderRadius: "50%",
                            width: "40px",
                            height: "40px",
                            marginBottom: "10px"
                          }}
                        />
                        <UncontrolledTooltip placement="top" target={tooltipId}>
                          {item.assigned_to?.name}
                        </UncontrolledTooltip>
                      </div>
                    ) : item.assigned_to?.name ? (
                      <div>
                        <InitialsAvatar
                          name={item.assigned_to?.name}
                          id={tooltipId}
                          userColor={
                            userColors.find(user => user.id === item.assigned_to?.id)?.color
                          }
                          dimensions="25px"
                          marginBottom="0"
                        />
                        <UncontrolledTooltip placement="top" target={tooltipId}>
                          {item.assigned_to?.name}
                        </UncontrolledTooltip>
                      </div>
                    ) : (
                      <img
                        src={profileImg}
                        alt="default profile"
                        style={{ height: "30px", width: "30px" }}
                      />
                    )}
                  </Col>

                  <Col md="1" className="text-center" style={{fontSize:'smaller'}}>
                    {getLocalDateTime(item.opened_at)}
                  </Col>

                  <Col md="1" className="text-center" style={{fontSize:'smaller'}}>
                    {getLocalDateTime(item.closed_at)}
                  </Col>
                </Row>
              </CardItem>
            );
          })}
          {alert_correlation_data?.associated_alerts?.length > 0 && render_view_metrics_button ? (
            <h5 className="mt-3">Detailed Analysis of Root Cause Alert</h5>
          ) : null}
          <Row className="p-2">
            <Col xs="2">Instance</Col>
            <Col xs="10" className="ps-4 ps-md-0 text-start">{alert?.resource_name || alert?.resource_id}</Col>
          </Row>
          <Row className="p-2 align-items-center">
            <Col xs="2">Source</Col>
            <Col xs="10" className="ps-4 ps-md-0 text-start">
              <img
                src={getIntegrationLogo(alert?.integration_type)}
                alt={alert?.integration_type}
                className="avatar-xs rounded-circle"
              />
            </Col>
          </Row>
          <Row className="p-2">
            <Col xs="2">Metric</Col>
            <Col xs="10" className="ps-4 ps-md-0 text-start">{alert?.metric_name}</Col>
          </Row>
          <Row className="p-2">
            {alertStatusHistory?.status_history && alertStatusHistory.status_history.length > 0 ? (
              <>
              <Col xs="2">Timeline</Col>
              <Col xs="10" className="ps-4 ps-md-0 text-start">
                {alertStatusHistory?.status_history && alertStatusHistory.status_history.length > 0 ? (
                  <div className="table-responsive">
                    <SlickHorizontalTimeline
                      events={alertStatusHistory?.status_history_for_timeline_view}
                      isOngoing={isOngoing}
                      eventCount={alertStatusHistory?.status_history.length}
                    />
                  </div>
                ) : (
                  <div>No status history available</div>
                )}
            </Col>
              </>
              ):
              <>
              <Col xs="2">Runbook</Col>
              <Col xs="10" className="ps-4 ps-md-0 text-start">
                {runbook && runbook.length > 0 ? (
                  <div className="table-responsive">
                    Generated
                  </div>
                ) : (
                  <div>Not available</div>
                )}
              </Col>
              </>
            }
          </Row>
          {alert?.correlated_metrics && alert?.correlated_metrics.length > 0 && render_view_metrics_button? (
            <Row className="p-2">
              <Col xs="2">Analysed Metrics</Col>
              <Col xs="10" className="ps-4 ps-md-0 text-start">
                <Row>
                  <Col xs="6">
                    <ul>
                      {alert?.correlated_metrics.slice(0, Math.ceil(alert?.correlated_metrics.length / 2)).map((metric, index) => (
                        <li key={index}>
                          {metric}
                        </li>
                      ))}
                    </ul>
                  </Col>
                  <Col xs="6">
                    <ul>
                      {alert?.correlated_metrics.slice(Math.ceil(alert?.correlated_metrics.length / 2)).map((metric, index) => (
                        <li key={index + Math.ceil(alert?.correlated_metrics.length / 2)}>
                          {metric}
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : null}
          {Object.keys(metrics_data_by_alert_log_id).length > 1 && render_view_metrics_button ? (
            <Row>
              <h5>Anomaly Observed</h5>
            </Row>) : null}
          <div className="d-flex flex-column">
            {Object.keys(metrics_data_by_alert_log_id).length > 1 &&
              (alert?.integration_type === "CloudWatch" || alert?.integration_type === "NewRelic") && (() => {
                const metricsEntries = Object.entries(metrics_data_by_alert_log_id);
                let rootCauseIndex = -1;
                metricsEntries.forEach(([key, value], index) => {
                  try {
                    const metadata = JSON.parse(alert?.alert_log_metadata || "{}");
                    const root_cause = metadata?.root_cause || '';
                    if (root_cause === value?.Label) {
                      rootCauseIndex = index;
                    }
                  } catch (error) {
                    console.error("Failed to parse alert metadata:", error);
                  }
                });
                const primaryMetricIndex = rootCauseIndex !== -1 ? rootCauseIndex : 0;
                const visibleMetrics = showAllMetrics
                  ? metricsEntries
                  : [metricsEntries[primaryMetricIndex]];

                return (
                  <>
                    {render_view_metrics_button ? (
                      <Row>
                        {visibleMetrics.map(([key, value], index) => {
                          const chartData = value?.Timestamps?.map((timestamp, index) => ({
                            timestamp,
                            value: value?.Values[index],
                          }));

                          let spikedMetricsIndexes = {};
                          let root_cause_metric = false;

                          try {
                            const metadata = JSON.parse(alert?.alert_log_metadata || "{}");
                            spikedMetricsIndexes = metadata?.spiked_metrics_indexes || {};
                            const root_cause = metadata?.root_cause || '';
                            if (root_cause === value?.Label) {
                              root_cause_metric = true;
                            }
                          } catch (error) {
                            console.error("Failed to parse alert metadata:", error);
                          }

                          const spikedIndexes = spikedMetricsIndexes[key] || [];
                          const chartConfig = {
                            title: "Metric Data",
                            timestampKey: "timestamp",
                            valueKey: "value",
                            timestampFormat: "time",
                            yAxisLabel: value?.Label,
                            height: "300px",
                            color: "#6df4a1",
                            spikedIndexes: spikedIndexes,
                          };

                          return (
                            <Col md="6" key={key} className="mb-3">
                              <SingleMetricChart
                                data={chartData}
                                config={chartConfig}
                                rootCauseMetric={false}
                              />
                            </Col>
                          );
                        })}
                      </Row>
                    ) : null}
                  </>
                );
              })()}
          </div>
          {render_view_metrics_button? (
            <>
              <Row className={'w-100'}>
                {Object.keys(metrics_data_by_alert_log_id).length > 0 ? (
                  <h5>Root Cause Metric</h5>
                ):null}
                <div className="d-flex justify-content-center flex-column">
                  {Object.keys(metrics_data_by_alert_log_id).length > 0 &&
                    (alert?.integration_type === "CloudWatch" || alert?.integration_type === "NewRelic") && (() => {
                      const metricsEntries = Object.entries(metrics_data_by_alert_log_id);
                      let rootCauseMetric = null;
                      let rootCauseKey = null;

                      // Find only the root cause metric
                      for (const [key, value] of metricsEntries) {
                        try {
                          const metadata = JSON.parse(alert?.alert_log_metadata || "{}");
                          const root_cause = metadata?.root_cause || '';
                          if (root_cause === value?.Label) {
                            rootCauseMetric = value;
                            rootCauseKey = key;
                            break; // Exit the loop once we find the root cause
                          }
                        } catch (error) {
                          console.error("Failed to parse alert metadata:", error);
                        }
                      }

                      // If no root cause found, render nothing
                      if (!rootCauseMetric) return null;

                      // Process only the root cause metric
                      const chartData = rootCauseMetric?.Timestamps?.map((timestamp, index) => ({
                        timestamp,
                        value: rootCauseMetric?.Values[index],
                      }));

                      let spikedMetricsIndexes = {};

                      try {
                        const metadata = JSON.parse(alert?.alert_log_metadata || "{}");
                        spikedMetricsIndexes = metadata?.spiked_metrics_indexes || {};
                      } catch (error) {
                        console.error("Failed to parse alert metadata:", error);
                      }

                      const spikedIndexes = spikedMetricsIndexes[rootCauseKey] || [];
                      const chartConfig = {
                        title: "Metric Data",
                        timestampKey: "timestamp",
                        valueKey: "value",
                        timestampFormat: "time",
                        yAxisLabel: rootCauseMetric?.Label,
                        height: "300px",
                        color: "#6df4a1",
                        spikedIndexes: spikedIndexes,
                      };

                      return (
                        <Row>
                          <div className={'d-flex justify-content-center mb-3'}>
                            <SingleMetricChart
                              data={chartData}
                              config={chartConfig}
                              rootCauseMetric={true}
                            />
                          </div>
                        </Row>
                      );
                    })()}
                </div>
              </Row>
              {runbook_results_by_alert_log_id?.lambda_results?.length> 0? (
                <>
                  <h4 className={'mb-4'}>Executed Lambda Results</h4>
                  {Object.entries(runbook_results_by_alert_log_id.lambda_results).map(([key, value]) => {
                    return (
                      <div key={key} className={'mb-2 ms-3'}
                           style={{
                             border: 'solid 0.05rem',
                             borderColor: 'white',
                             padding: '0.5rem',
                             borderRadius: '5px',
                           }}
                      >
                        <Row className="mb-2">
                          <Col md={1}>Lambda Name:</Col>
                          <Col md={9}>{value?.lambda_name}</Col>
                        </Row>
                        <Row>
                          <Col md={1}>Result: </Col>
                          <Col md={11}>{renderResult(value?.result)}</Col>
                        </Row>
                      </div>
                    )
                  })}
                </>
              ):null}
              {user_executed_results_by_alert_log_id?.length > 0 ? (
                <>
                  <h4 className={'mb-4'}>Vibe Troubleshooting Commands</h4>
                  {user_executed_results_by_alert_log_id
                    .slice(0, showAllTroubleshooting ? undefined : 2)
                    .map((item, index) => (
                    <div key={item.id || index} className={'mb-2 ms-3'}
                         style={{
                           border: 'solid 0.05rem',
                           borderColor: item?.is_error ? 'red' : 'white',
                           padding: '0.5rem',
                           borderRadius: '5px',
                         }}
                    >
                      <Row>
                        <Col md={1}>Code:</Col>
                        {item?.initiated_by ? (
                          <>
                            <Col md={8}>
                              <pre style={{
                                padding: "10px",
                                color: "#FFB680",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                backgroundColor: 'black'
                              }}>
                                {item?.user_command}
                              </pre>
                            </Col>
                            <Col md={3} style={{ textAlign: "right" }}>
                              <small>By: {item.initiated_by} at {getLocalDateTime(item.created_at)}</small>
                            </Col>
                          </>
                        ) : (
                          <Col md={11}>
                            <pre style={{
                              padding: "10px",
                              color: "#FFB680",
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                              backgroundColor: 'black'
                            }}>
                              {item?.user_command}
                            </pre>
                          </Col>
                        )}
                      </Row>
                      <Row>
                        <Col md={1}>Result:</Col>
                        <Col md={11}>{renderResult(item?.result)}</Col>
                      </Row>
                    </div>
                  ))}
                  {user_executed_results_by_alert_log_id.length > 2 && (
                    <div className="text-center mt-3">
                      <button
                        className="btn btn-primary"
                        onClick={() => setShowAllTroubleshooting(!showAllTroubleshooting)}
                      >
                        {showAllTroubleshooting ? 'Show Less' : `Show ${user_executed_results_by_alert_log_id.length - 2} More`}
                      </button>
                    </div>
                  )}
                </>
              ) : null}
              {runbook_results_by_alert_log_id?.diagnostics?.length> 0? (
                <>
                  <h4 className={'mb-4'}>Executed Diagnostics Results</h4>
                  {Object.entries(runbook_results_by_alert_log_id.diagnostics).map(([key, value]) => {
                    return (
                      <div key={key} className={'mb-2 ms-3'}
                           style={{
                             border: 'solid 0.05rem',
                             borderColor: value?.is_error ? 'red' : 'white',
                             padding: '0.5rem',
                             borderRadius: '5px',
                           }}
                      >
                        <Row className="mb-2">
                          <Col md={1}>Instruction:</Col>
                          {value?.ran_by ? (
                            <>
                              <Col md={7}>{value?.instruction || '—'}</Col>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <small>By: {value.ran_by} at {getLocalDateTime(value.ran_at)}</small>
                              </Col>
                            </>
                          ) : (
                            <>
                              <Col md={9}>{value?.instruction || '—'}</Col>
                              <Col md={2} style={{ textAlign: "right" }}>
                                <small>{getLocalDateTime(value.ran_at)}</small>
                              </Col>
                            </>
                          )}
                        </Row>
                        <Row>
                          <Col md={1}>Code:</Col>
                          <Col md={11} ><pre style={{
                            padding: "10px",
                            color: "#FFB680",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            backgroundColor: 'black'
                          }}
                          >{value?.code}</pre></Col>
                        </Row>
                        <Row>
                          <Col md={1}>Result: </Col>
                          <Col md={11}>{renderResult(value?.result)}</Col>
                        </Row>
                      </div>
                    )
                  })}
                </>
              ):null}
              {runbook_results_by_alert_log_id?.recovery_instructions?.length> 0? (
                <>
                  <h4 className={'mb-3 mt-3'}>Executed Recovery Results</h4>
                  {Object.entries(runbook_results_by_alert_log_id.recovery_instructions).map(([key, value]) => {
                    return (
                      <div key={key} className={'mb-2 ms-3'}
                           style={{
                             border: 'solid 0.05rem',
                             borderColor: value?.is_error ? 'red' : 'white',
                             padding: '0.5rem',
                             borderRadius: '5px',
                           }}
                      >
                        <Row className="mb-2">
                          <Col md={1}>Instruction:</Col>
                          {value?.ran_by ? (
                            <>
                              <Col md={7}>{value?.instruction || '—'}</Col>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <small>By: {value.ran_by} at {getLocalDateTime(value.ran_at)}</small>
                              </Col>
                            </>
                          ) : (
                            <>
                              <Col md={9}>{value?.instruction || '—'}</Col>
                              <Col md={2} style={{ textAlign: "right" }}>
                                <small>{getLocalDateTime(value.ran_at)}</small>
                              </Col>
                            </>
                          )}
                        </Row>
                        <Row>
                          <Col md={1}>Code:</Col>
                          <Col md={11} ><pre style={{
                            padding: "10px",
                            color: "#FFB680",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            backgroundColor: 'black'
                          }}
                          >{value?.code}</pre></Col>
                        </Row>
                        <Row>
                          <Col md={1}>Result: </Col>
                          <Col md={11}>{renderResult(value?.result)}</Col>
                        </Row>
                      </div>
                    )
                  })}
                </>
              ):null}
              <Row className="p-2">
                {
                  runbook.length > 0 && !runbook_results_by_alert_log_id?.lambda_results ? (
                    <>
                      <div ref={runbookRef} className="d-none d-md-block">
                        {runbookView ? (
                          <Runbook
                            runbookView={runbookView}
                            handleView={viewRunbook}
                            id={alert?.id}
                            runbook_id={runbook[currentRunbookIndex].runbook?.id}
                            metricName={alert?.metric_name}
                          />
                        ) : (
                          <div className="d-none d-md-block">
                            <Runbook
                              runbookView={runbookView}
                              handleView={viewRunbook}
                              id={alert?.id}
                              runbook_id={runbook[currentRunbookIndex].runbook?.id}
                              metricName={alert?.metric_name}
                            />

                            {runbook[currentRunbookIndex]?.runbook && !runbookView ? (
                              <div className="d-flex align-items-center ps-4">
                                <button
                                  className="btn btn-primary relative justify-self-end"
                                  onClick={viewRunbook}
                                >
                                  See more
                                </button>
                                <div style={{ marginLeft: "5%" }} className="d-flex align-items-center">
                                  {runbook.length > 1 && (
                                    <div className="d-flex">
                                      <button
                                        className="btn btn-secondary me-2"
                                        onClick={() =>
                                          setCurrentRunbookIndex(prev =>
                                            prev === 0 ? runbook.length - 1 : prev - 1
                                          )
                                        }
                                      >
                                        Previous
                                      </button>
                                      <span className="me-2 mt-2">
                                      Runbook {currentRunbookIndex + 1} of {runbook.length}
                                    </span>
                                      <button
                                        className="btn btn-secondary"
                                        onClick={() =>
                                          setCurrentRunbookIndex(prev =>
                                            prev === runbook.length - 1 ? 0 : prev + 1
                                          )
                                        }
                                      >
                                        Next
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    !runbook_results_by_alert_log_id?.lambda_results && (
                      <div
                        style={{ fontSize: "20px", margin: "auto 40px" }}
                        className="d-none d-md-flex flex-row align-items-center ms-3"
                      >
                        No runbook available
                        <div className="mx-5 my-1">
                          <button
                            onClick={() => setCreateRunbookView(true)}
                            className="btn btn-primary"
                          >
                            Create
                          </button>
                        </div>
                      </div>
                    )
                  )
                }
              </Row>
              {createRunbookView ? (
                <div className="w-100 d-none d-md-block">
                  <CreateRunbook alert_log_id={alert?.id}/>
                </div>
              ):null}
            </>
          ):null}
        </div>
      </div>
    {agent_availability?.render_agent_chat ? (
      render_view_metrics_button ? (
            <>
              {/* Floating Chat Sidebar */}
              <div style={{
                position: 'fixed',
                top: '100px',
                right: 0,
                width: '25%',
                height: '80vh',
                backgroundColor: '#1a1025',
                borderLeft: '1px solid #3a2a4a',
                zIndex: 10,
                display: 'flex',
                flexDirection: 'column'
              }}>
                {/* Chat Header */}
                <div style={{
                  backgroundColor: '#2a1a3a',
                  padding: '16px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid #3a2a4a'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                      width: '36px',
                      height: '36px',
                      backgroundColor: '#6e45a0',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '12px'
                    }}>
                      <img src="/icons/temperstack.svg" alt="Temperstack" className="text-white" style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} />
                    </div>
                    <div>
                      <h5 style={{
                        color: 'white',
                        margin: 0,
                        fontWeight: '600',
                        fontSize: '1.1rem'
                      }}>Temperstack SRE Assistant</h5>
                      <div style={{
                        color: '#b39ddb',
                        fontSize: '0.75rem',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                      <span style={{
                        display: 'inline-block',
                        width: '8px',
                        height: '8px',
                        backgroundColor: '#4cd137',
                        borderRadius: '50%',
                        marginRight: '6px'
                      }}></span>
                        Online
                      </div>
                    </div>
                  </div>
                </div>
                {/* Chat Messages */}
                <div
                  style={{
                    overflowY: 'auto',
                    padding: '20px',
                    flex: 1,
                    backgroundColor: '#1a1025',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#6e45a0 #1a1025'
                  }}
                >
                  {messages.map((message, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: '16px',
                        maxWidth: '85%',
                        marginLeft: message.type === 'user' ? 'auto' : '0',
                        marginRight: message.type === 'user' ? '0' : 'auto'
                      }}
                    >
                      <div style={{
                        color: message.type === 'ai' ? '#b39ddb' : '#e0d6f0',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                        marginBottom: '4px',
                        paddingLeft: message.type === 'ai' ? '8px' : '0',
                        paddingRight: message.type === 'user' ? '8px' : '0',
                        textAlign: message.type === 'user' ? 'right' : 'left'
                      }}>
                        {message.type === 'ai' ? 'Temperstack Agent' : message.user_name || 'You'}
                      </div>
                      <div
                        style={{
                          backgroundColor: message.type === 'ai' ? '#2a1a3a' : '#6e45a0',
                          color: 'white',
                          padding: '12px 16px',
                          borderRadius: message.type === 'ai' ? '8px 8px 8px 0px' : '8px 8px 0px 8px',
                          lineHeight: '1.5',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          border: message.type === 'ai' ? '1px solid #3a2a4a' : '1px solid #7d5bb8',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word'
                        }}
                      >
                        {message.type === 'ai' ? (
                          <div style={{ padding: '5px 10px' }}>
                            {renderMessageWithCodeBlocks(String(message.content))}
                          </div>
                        ) : (
                          String(message.content)
                        )}
                      </div>
                      <div style={{
                        color: 'rgba(255,255,255,0.4)',
                        fontSize: '0.7rem',
                        textAlign: message.type === 'user' ? 'right' : 'left',
                        padding: '4px 8px 0'
                      }}>
                        {message.timestamp ? getLocalDateTime(message.timestamp) :new Date().toLocaleString() }
                      </div>
                    </div>
                  ))}
                  {stateApprovalRequired && (
                    <div
                      style={{
                        marginBottom: '16px',
                        maxWidth: '85%',
                        marginLeft: '0',
                        marginRight: 'auto'
                      }}
                    >
                      <div
                        style={{
                          color: '#d4bfff',
                          fontSize: '0.8rem',
                          fontWeight: '700',
                          marginBottom: '6px',
                          paddingLeft: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}
                      >
                        <span>⚠️</span> User Action
                      </div>

                      <div
                        style={{
                          background: 'rgba(42, 26, 58, 0.85)',
                          color: 'white',
                          padding: '20px',
                          borderRadius: '16px 16px 16px 6px',
                          lineHeight: '1.6',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                          border: '1px solid #3a2a4a',
                          backdropFilter: 'blur(6px)',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word'
                        }}
                      >
                        <div style={{ marginBottom: '15px' }}>
                          {approval_message || approvalMessage}
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            gap: '10%',
                            justifyContent: 'space-between'
                          }}
                        >
                          <button
                            onClick={() => handleApprovalResponse(true)}
                            style={{
                              backgroundColor: '#077351',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              padding: '4px 6px',
                              cursor: 'pointer',
                              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                              width: '45%'
                            }}
                            onMouseOver={(e) => {
                              e.target.style.backgroundColor = '#077351';
                              e.target.style.transform = 'translateY(-1px)';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.backgroundColor = '#077351';
                              e.target.style.transform = 'translateY(0)';
                            }}
                          >
                            Approve
                          </button>
                          <button
                            onClick={() => handleApprovalResponse(false)}
                            style={{
                              backgroundColor: '#a81616',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              padding: '4px 6px',
                              cursor: 'pointer',
                              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                              width: '45%'
                            }}
                            onMouseOver={(e) => {
                              e.target.style.backgroundColor = '#a81616';
                              e.target.style.transform = 'translateY(-1px)';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.backgroundColor ='#a81616';
                              e.target.style.transform = 'translateY(0)';
                            }}
                          >
                            Decline
                          </button>
                        </div>
                      </div>

                      <div
                        style={{
                          color: 'rgba(255,255,255,0.4)',
                          fontSize: '0.7rem',
                          textAlign: 'left',
                          padding: '4px 8px 0'
                        }}
                      >
                        {new Date().toLocaleString()}
                      </div>
                    </div>
                  )}
                  {isStreaming && (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px',
                      color: '#b39ddb',
                      fontStyle: 'italic'
                    }}>
                      <div className="spinner-grow spinner-grow-sm me-2" role="status" style={{ color: '#b39ddb' }}>
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <div style={{
                        position: 'relative',
                        display: 'inline-block'
                      }}>
                    <span style={{
                      display: 'inline-block',
                      animation: 'typing 2s steps(3, end) infinite'
                    }}>
                      Processing
                    </span>
                        <span style={{
                          display: 'inline-block',
                          animation: 'blink 2s steps(7, end) infinite'
                        }}>...</span>
                      </div>
                    </div>
                  )}
                  <style>
                    {`
                  @keyframes typing {
                    0% { opacity: 0.4; transform: translateY(0px); }
                    20% { opacity: 0.6; transform: translateY(-1px); }
                    40% { opacity: 0.8; transform: translateY(-2px); }
                    50% { opacity: 1; transform: translateY(-2px); }
                    60% { opacity: 0.8; transform: translateY(-2px); }
                    80% { opacity: 0.6; transform: translateY(-1px); }
                    100% { opacity: 0.4; transform: translateY(0px); }
                  }
                  @keyframes blink {
                    0% { opacity: 0; transform: scale(0.5); }
                    30% { opacity: 0.4; transform: scale(0.75); }
                    50% { opacity: 1; transform: scale(1); }
                    70% { opacity: 0.4; transform: scale(0.75); }
                    100% { opacity: 0; transform: scale(0.5); }
                  }
                `}
                  </style>
                  <div ref={messagesEndRef} />
                </div>
                {/* Chat Input */}
                <div style={{
                  padding: '16px',
                  backgroundColor: '#2a1a3a',
                  borderTop: '1px solid #3a2a4a'
                }}>
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type your SRE question..."
                      value={aiChatMessage}
                      onChange={(e) => setAiChatMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSendMessage();
                      }}
                      disabled={isStreaming}
                      style={{
                        backgroundColor: '#251a35',
                        color: 'white',
                        border: '1px solid #3a2a4a',
                        borderRadius: '8px',
                        padding: '12px 50px 12px 20px',
                        height: '48px',
                        boxShadow: 'none'
                      }}
                    />
                    <button
                      onClick={handleSendMessage}
                      disabled={isStreaming || !aiChatMessage.trim()}
                      style={{
                        position: 'absolute',
                        right: '8px',
                        top: '8px',
                        backgroundColor: aiChatMessage.trim() ? '#6e45a0' : '#3a2a4a',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: aiChatMessage.trim() ? 'pointer' : 'not-allowed',
                        transition: 'background-color 0.2s'
                      }}
                    >
                      <i className="fas fa-paper-plane"></i>
                    </button>
                  </div>
                  <div style={{
                    color: '#b39ddb',
                    fontSize: '0.75rem',
                    textAlign: 'center',
                    marginTop: '8px'
                  }}>
                    Ask about this alert, resolution steps, or more details on the root cause
                  </div>
                </div>
              </div>
            </>
          ):(
          <Row className="p-1 d-flex" style={{marginLeft:'5%', marginRight:"5%", width:'90%'}}>
            <div className={'d-flex flex-column justify-content-center'}>
              <div
                style={{
                  backgroundColor: '#2a1a3a',
                  padding: '5px 10px',
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid #3a2a4a',
                  borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      width: '36px',
                      height: '36px',
                      backgroundColor: '#6e45a0',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '12px',
                    }}
                  >
                    <img src="/icons/temperstack.svg" alt="Temperstack" className="text-white" style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} />
                  </div>
                  <div>
                    <h5
                      style={{
                        color: 'white',
                        margin: 0,
                        fontWeight: 600,
                        fontSize: '1.1rem',
                      }}
                    >
                      Temperstack SRE Assistant
                    </h5>
                    <div
                      style={{
                        color: '#b39ddb',
                        fontSize: '0.75rem',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <span
                        style={{
                          width: '8px',
                          height: '8px',
                          backgroundColor: '#4cd137',
                          borderRadius: '50%',
                          marginRight: '6px',
                        }}
                      />
                     Online
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="text-white px-4 py-3"
                style={{
                  backgroundColor: '#1f142b',
                  borderLeft: '1px solid #3a2a4a',
                  borderRight: '1px solid #3a2a4a',
                }}
              >
                {messages.length > 0 && (() => {
                  const message = messages[0];
                  return (
                    <div
                      style={{
                        marginBottom: '16px',
                        maxWidth: '85%',
                        marginLeft: message.type === 'user' ? 'auto' : '0',
                        marginRight: message.type === 'user' ? '0' : 'auto'
                      }}
                    >
                      <div style={{
                        color: message.type === 'ai' ? '#b39ddb' : '#e0d6f0',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                        marginBottom: '4px',
                        paddingLeft: message.type === 'ai' ? '8px' : '0',
                        paddingRight: message.type === 'user' ? '8px' : '0',
                        textAlign: message.type === 'user' ? 'right' : 'left'
                      }}>
                        {message.type === 'ai' ? 'Temperstack Agent' : message.user_name || 'You'}
                      </div>
                      <div
                        style={{
                          backgroundColor: message.type === 'ai' ? '#2a1a3a' : '#6e45a0',
                          color: 'white',
                          padding: '5px 10px',
                          borderRadius: message.type === 'ai' ? '8px 8px 8px 0px' : '8px 8px 0px 8px',
                          lineHeight: '1.5',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          border: message.type === 'ai' ? '1px solid #3a2a4a' : '1px solid #7d5bb8',
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word'
                        }}
                      >
                        {message.type === 'ai' ? (
                          <div style={{ padding: '5px 10px' }}>
                            {renderMessageWithCodeBlocks(String(message.content))}
                          </div>
                        ) : (
                          String(message.content)
                        )}
                      </div>
                      <div style={{
                        color: 'rgba(255,255,255,0.4)',
                        fontSize: '0.7rem',
                        textAlign: message.type === 'user' ? 'right' : 'left',
                        padding: '4px 8px 0'
                      }}>
                        {message.timestamp ? getLocalDateTime(message.timestamp) : new Date().toLocaleString()}
                      </div>
                    </div>
                  );
                })()}
              </div>
                <div
                  style={{
                    backgroundColor: '#2a1a3a',
                    padding: '8px',
                    borderTop: '1px solid #3a2a4a',
                    borderLeft: '1px solid #3a2a4a',
                    borderRight: '1px solid #3a2a4a',
                    borderBottomLeftRadius: '12px',
                    borderBottomRightRadius: '12px',
                  }}
                >
                  <div style={{ position: 'relative' }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type your SRE question..."
                      value={aiChatMessage}
                      onChange={(e) => setAiChatMessage(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSendMessage();
                      }}
                      disabled={isStreaming}
                      style={{
                        backgroundColor: '#251a35',
                        color: 'white',
                        border: '1px solid #3a2a4a',
                        borderRadius: '20px',
                        padding: '12px 50px 12px 20px',
                        height: '48px',
                        boxShadow: 'none',
                      }}
                    />
                    <button
                      onClick={handleSendMessage}
                      disabled={isStreaming || !aiChatMessage.trim()}
                      style={{
                        position: 'absolute',
                        right: '8px',
                        top: '8px',
                        backgroundColor: aiChatMessage.trim() ? '#6e45a0' : '#3a2a4a',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: aiChatMessage.trim() ? 'pointer' : 'not-allowed',
                        transition: 'background-color 0.2s',
                      }}
                    >
                      <i className="fas fa-paper-plane" />
                    </button>
                  </div>
                  {/* Helper Text */}
                  <div
                    style={{
                      color: '#b39ddb',
                      fontSize: '0.75rem',
                      textAlign: 'center',
                      marginTop: '8px',
                    }}
                  >
                    Ask about this alert, resolution steps, or more details on the root cause
                  </div>
                </div>
            </div>
          </Row>)
    ):null}

    </>
  )
}

export default RootCauseAnalysis;